import React, { useState } from 'react'
import {
  Flex,
  FormField,
  Modal,
  PrimaryButton,
  Select,
  SelectOption,
  space,
  useAssistiveHideSiblings,
  useDisableBodyScroll,
  useFocusTrap,
  useInitialFocus,
  useModalModel,
  useReturnFocus
} from '@workday/canvas-kit-react'
import TimeDisplayOption, { timeDisplayOptions, timeDisplayOptionDescription } from '../models/TimeDisplayOptions'
import { PrimaryButtonColors } from '../../components/CanvasThemes'
import styled from '@emotion/styled'

export type DisplaySettingData = {
  timeDisplay: TimeDisplayOption
}

export type DisplaySettingsProps = {
  data: DisplaySettingData
  onUpdate: (data: DisplaySettingData) => void
  onCancel: () => void
}

const StyledModalOverlay = styled(Modal.Overlay)`
  >div {
    align-items: center!important;
  }
`

const DisplaySettings = ({ data, onUpdate, onCancel }: DisplaySettingsProps) => {
  const [timeDisplay, setTimeDisplay] = useState(data.timeDisplay)

  const model = useModalModel()
  useInitialFocus(model)
  useReturnFocus(model)
  useFocusTrap(model)
  useAssistiveHideSiblings(model)
  useDisableBodyScroll(model)
  model.state.visibility = 'visible'

  return (
    <Modal model={model}>
      <StyledModalOverlay>
        <Modal.Card>
          <Modal.Body>
            <FormField label="Time Display">
              <Select
                value={timeDisplay}
                onChange={event => setTimeDisplay(event.currentTarget.value as TimeDisplayOption)}
              >
                {timeDisplayOptions.map(option => (
                  <SelectOption value={option} key={option} label={timeDisplayOptionDescription(option)} />
                ))}
              </Select>
            </FormField>
            <Flex flexDirection="row" gap={space.xs}>
              <PrimaryButton
                onClick={event => {
                  onUpdate({ timeDisplay: timeDisplay })
                }}
                colors={PrimaryButtonColors}
              >
                Save
              </PrimaryButton>
              <Modal.CloseButton onClick={event => onCancel()}>Cancel</Modal.CloseButton>
            </Flex>
          </Modal.Body>
        </Modal.Card>
      </StyledModalOverlay>
    </Modal>
  )
}

export default DisplaySettings
